import { useDatabase } from "@nozbe/watermelondb/hooks";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  Card,
  FlatActionList,
  Page,
  useFlashMessages,
} from "@towersystems/roam-common-native";
import { useEffect, useState } from "react";
import { LoaderScreen } from "react-native-ui-lib";
import { SettingsRootParamList } from "../../../../types";
import Sale from "../../../../utilities/data/model/Sale";
import { useDownloadJson } from "../../../../utilities/download-json";
import { useSaleSyncProvider } from "../../../../utilities/sale-sync";

export type SaleInQueueOptionsScreenProps = NativeStackScreenProps<
  SettingsRootParamList,
  "SaleInQueueOptionsScreen"
>;

export const SaleInQueueOptionsScreen = ({
  navigation,
  route,
}: SaleInQueueOptionsScreenProps) => {
  const { download } = useDownloadJson();
  const sync = useSaleSyncProvider();
  const [sale, setSale] = useState<Sale | undefined>(undefined);
  const database = useDatabase();
  const saleId = route.params.saleId;
  const { showMessage } = useFlashMessages();

  useEffect(() => {
    if (sale) {
      navigation.setOptions({
        headerTitleAlign: "center",
        title: `#${sale.invoiceNumber}`,
      });
    }
  }, [sale]);

  useEffect(() => {
    database
      .get<Sale>("sales")
      .find(saleId)
      .then((sale) => {
        if (sale) {
          if (["UPLOADED", "MODIFIED"].includes(sale.syncState)) {
            navigation.goBack();
          }
          setSale(sale);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const handleOnDownload = async () => {
    if (sale) {
      const formattedSale = await sync.formatSale(sale);
      download({
        data: formattedSale,
        fileName: `sale-${sale.invoiceNumber}.json`,
      });
    }
  };

  const loadingMarkup = !sale ? <LoaderScreen /> : undefined;
  const optionsMarkup = sale ? (
    <Card>
      <FlatActionList
        items={[
          {
            key: "json",
            title: "Download JSON",

            onPress: async () => {
              return handleOnDownload().catch((err) => {
                console.log(err);
                showMessage({
                  message: err.message,
                  severity: "error",
                });
              });
            },
          },
          {
            key: "sync",
            isAction: true,
            title: "Sync Sale",
            onPress: () =>
              sync
                .processAndSyncSaleById(sale.id)
                .then(() => navigation.goBack())
                .catch((err) => console.log(err)),
          },

          {
            key: "delete",
            destructive: true,
            title: "Delete Sale",
            onPress: () =>
              sync
                .removeItemFromQueue(sale.id)
                .then(() => navigation.goBack())
                .catch((err) => console.log(err)),
          },
        ]}
      ></FlatActionList>
    </Card>
  ) : undefined;

  return (
    <Page>
      {loadingMarkup}
      {optionsMarkup}
    </Page>
  );
};
